import React from 'react';

export class SliderContent extends React.Component {
  render() {
    const { index, key, img, title } = this.props;
    let mainClasses =
      index % 2 === 1 ? 'header-text d-md-flex bg-banner-alt' : 'header-text d-md-flex bg-banner';

    return (
      <React.Fragment>
        <div className={mainClasses} key={key}>
          <img src={img} alt={title} className="banner-image-cust" />
        </div>
      </React.Fragment>
    );
  }
}
